import { storesUkOnly, storesWithEuMarketplaces } from "./constants";

// Amazon's European marketplaces, in picker order. A flag only shows when the
// store's login payload lists that marketplace.
const EU_MARKETPLACES = [
  "uk",
  "de",
  "fr",
  "it",
  "es",
  "nl",
  "se",
  "pl",
  "be",
  "ie",
  "tr",
];

export const MARKETPLACE_FLAGS = {
  all: "🌏",
  us: "🇺🇸",
  ca: "🇨🇦",
  mx: "🇲🇽",
  uk: "🇬🇧",
  de: "🇩🇪",
  fr: "🇫🇷",
  it: "🇮🇹",
  es: "🇪🇸",
  nl: "🇳🇱",
  se: "🇸🇪",
  pl: "🇵🇱",
  be: "🇧🇪",
  ie: "🇮🇪",
  tr: "🇹🇷",
};

// The legacy JWT payload carries no marketplaces, so that path keeps reading
// the hardcoded store lists.
export const legacyStoreMarketplaces = (store) => {
  if (storesUkOnly.includes(store)) return ["uk"];
  if (storesWithEuMarketplaces.includes(store)) return ["us", "ca", "uk"];
  return [];
};

/**
 * The marketplaces the picker offers for a store.
 *
 * European data is only served on the P&L, Store Analysis and PPC pages, so
 * EU marketplaces appear there alone. A store that sells only in Europe gets
 * just its own flags on those pages; everywhere else US and CA stay on offer
 * as the default.
 */
export const offeredMarketplaces = ({
  storeMarketplaces,
  euPage = false,
  allowAll = false,
}) => {
  const eu = EU_MARKETPLACES.filter((code) => storeMarketplaces.includes(code));
  const euOnly =
    storeMarketplaces.length > 0 &&
    storeMarketplaces.every((code) => EU_MARKETPLACES.includes(code));
  if (euPage && euOnly) return eu;
  return [
    ...(allowAll ? ["all"] : []),
    "us",
    "ca",
    ...(storeMarketplaces.includes("mx") ? ["mx"] : []),
    ...(euPage ? eu : []),
  ];
};
